import React from "react";
import { Row, Col, Card, Badge } from "react-bootstrap";
import {
    FaExclamationTriangle,
    FaClock,
    FaCheckCircle,
    FaTimesCircle,
    FaClipboardList
} from "react-icons/fa";

const OcurrenciasStats = ({ ocurrencias }) => {
    const calcularEstadisticas = () => {
        const total = ocurrencias.length;
        const faltas = ocurrencias.filter(o => o.tipo === "falta").length;
        const tardanzas = ocurrencias.filter(o => o.tipo === "tardanza").length;
        const licencias = ocurrencias.filter(o =>
            ["vacaciones", "descanso_medico", "licencia", "permiso"].includes(o.tipo)
        ).length;
        const aprobadas = ocurrencias.filter(o => o.estado === "aprobado").length;
        const pendientes = ocurrencias.filter(o =>
            o.estado === "pendiente" || o.estado === "detectado_automatico"
        ).length;

        return { total, faltas, tardanzas, licencias, aprobadas, pendientes };
    };

    const stats = calcularEstadisticas();

    const StatCard = ({ icon: Icon, label, value, gradient, iconColor }) => (
        <Col md={4} lg={2} className="mb-3">
            <Card
                className="shadow-sm border-0 h-100"
                style={{
                    borderRadius: "15px",
                    background: gradient,
                    transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
            >
                <Card.Body className="p-3 text-center">
                    <div
                        className="rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center"
                        style={{
                            width: "50px",
                            height: "50px",
                            background: "rgba(255, 255, 255, 0.3)",
                        }}
                    >
                        <Icon size={24} style={{ color: iconColor }} />
                    </div>
                    <h3 className="fw-bold mb-1 text-white">{value}</h3>
                    <p className="mb-0 small text-white opacity-75">{label}</p>
                </Card.Body>
            </Card>
        </Col>
    );

    return (
        <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
            <Card.Body className="p-4">
                <Row className="g-3">
                    <StatCard
                        icon={FaClipboardList}
                        label="Total"
                        value={stats.total}
                        gradient="linear-gradient(135deg, #B8860B 0%, #DAA520 100%)"
                        iconColor="#FFF"
                    />
                    <StatCard
                        icon={FaTimesCircle}
                        label="Faltas"
                        value={stats.faltas}
                        gradient="linear-gradient(135deg, #dc3545 0%, #c82333 100%)"
                        iconColor="#FFF"
                    />
                    <StatCard
                        icon={FaClock}
                        label="Tardanzas"
                        value={stats.tardanzas}
                        gradient="linear-gradient(135deg, #ffc107 0%, #ff9800 100%)"
                        iconColor="#FFF"
                    />
                    <StatCard
                        icon={FaCheckCircle}
                        label="Licencias"
                        value={stats.licencias}
                        gradient="linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                        iconColor="#FFF"
                    />
                    <StatCard
                        icon={FaCheckCircle}
                        label="Aprobadas"
                        value={stats.aprobadas}
                        gradient="linear-gradient(135deg, #17a2b8 0%, #138496 100%)"
                        iconColor="#FFF"
                    />
                    <StatCard
                        icon={FaExclamationTriangle}
                        label="Pendientes"
                        value={stats.pendientes}
                        gradient="linear-gradient(135deg, #6c757d 0%, #5a6268 100%)"
                        iconColor="#FFF"
                    />
                </Row>
            </Card.Body>
        </Card>
    );
};

export default OcurrenciasStats;
